import {
  collection,
  addDoc,
  Timestamp,
  doc,
  getDoc,
} from "firebase/firestore";
import { db } from "./firebase";

/**
 * Copies a drill from drillTemplates into the user's designs collection.
 * @param {string} templateId Firestore document id in drillTemplates
 * @param {string} uid Firebase auth uid
 * @param {string} [title] Optional title override (e.g. onboarding show name)
 * @returns {Promise<string>} New design document id
 */
export async function createDesignFromTemplate(templateId, uid, title) {
  const drillRef = doc(db, "drillTemplates", templateId);
  const drillSnapshot = await getDoc(drillRef);

  if (!drillSnapshot.exists()) {
    throw new Error("Template not found");
  }

  const drillData = drillSnapshot.data();
  const { createdAt: _createdAt, ...dataToDuplicate } = drillData;
  const resolvedTitle = (title && String(title).trim()) || dataToDuplicate.title;

  const newDrillRef = await addDoc(collection(db, "designs"), {
    ...dataToDuplicate,
    title: resolvedTitle,
    createdAt: Timestamp.now(),
    createdBy: uid,
    updated: Timestamp.now(),
  });

  return newDrillRef.id;
}
